//Core
import React from "react"

//Style
import style from "./style.module.scss"

//helper
import { classes } from "../../../helpers/classname"

const { Wrapper, grid, number: count, image, textBox } = style

const OneStep = ({
  img,
  number = 1,
  text = `Замовте картку зараз`,
  color = "#d2b0c8",
}) => {
  return (
    <div className={classes(Wrapper, grid)}>
      <img src={img} alt={text + " | ТАСКОМБАНК"} className={image}></img>
      <div className={classes(count, grid)} style={{ color: color }}>
        {number}
      </div>
      <div className={textBox}>{text}</div>
    </div>
  )
}

export default OneStep
